module.exports = __webpack_public_path__ + "img/buyafeature.c3dc7b28.svg";